import React from "react";
import "./src/styles/app-menu.css";
import "./src/styles/global.css";

import { SiteProvider } from './src/context/SiteContext';

export const wrapRootElement = ({ element }) => {
  return <SiteProvider>{element}</SiteProvider>;
};